export default "__VITE_ASSET__CiqVDUrc__"